import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, InputAdornment, Tab, Tabs, TextField, Tooltip } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import { LICENCE_TYPES } from './assignmentModel';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
    },
    categoryTabs: {
        minHeight: 40,
        padding: 4,
        border: '1px solid var(--dm-border, #e1e7ee)',
        borderRadius: 9,
        backgroundColor: 'var(--dm-row-alt, #f8fafc)',
        '& .MuiTabs-indicator': {
            display: 'none',
        },
        '& .MuiTab-root': {
            minHeight: 32,
            minWidth: 0,
            flex: 1,
            padding: theme.spacing(0.5, 1.5),
            borderRadius: 7,
            color: 'var(--dm-muted, #647184)',
            fontSize: '0.75rem',
            fontWeight: 700,
            textTransform: 'none',
        },
        '& .Mui-selected': {
            color: theme.palette.primary.main,
            backgroundColor: 'var(--contentColor, #ffffff)',
            boxShadow: '0 2px 8px rgba(30, 48, 70, 0.1)',
        },
    },
    controls: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) auto',
        gap: theme.spacing(1.5),
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'minmax(0, 1fr)',
        },
    },
    search: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            backgroundColor: 'var(--contentColor, #ffffff)',
        },
    },
    quickAssign: {
        whiteSpace: 'nowrap',
        textTransform: 'none',
        fontWeight: 700,
    },
}));

const SearchField = ({ value, onChange, placeholder, className }) => (
    <TextField
        variant="outlined"
        size="small"
        fullWidth
        value={value}
        placeholder={placeholder}
        onChange={event => onChange(event.target.value)}
        className={className}
        inputProps={{ 'aria-label': placeholder }}
        InputProps={{
            startAdornment: (
                <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>
            ),
        }}
    />
);

const AssignmentToolbar = ({
    category,
    onCategoryChange,
    countsByType,
    totalLicences,
    userSearch,
    onUserSearchChange,
    licenceSearch,
    onLicenceSearchChange,
    onQuickAssign,
    disabled,
    disabledReason,
}) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Tabs
                className={classes.categoryTabs}
                value={category}
                onChange={(event, value) => onCategoryChange(value)}
                variant="scrollable"
                scrollButtons="off"
                aria-label="Licence categories"
            >
                <Tab value="all" label={`All licences (${totalLicences})`} />
                {LICENCE_TYPES.map(({ type, plural }) => (
                    <Tab key={type} value={type} label={`${plural} (${countsByType[type] || 0})`} />
                ))}
            </Tabs>
            <div className={classes.controls}>
                <SearchField
                    value={userSearch}
                    onChange={onUserSearchChange}
                    placeholder="Search users by email or name"
                    className={classes.search}
                />
                <SearchField
                    value={licenceSearch}
                    onChange={onLicenceSearchChange}
                    placeholder="Search licences"
                    className={classes.search}
                />
                <Tooltip title={disabled && disabledReason ? disabledReason : ''} arrow>
                    <span>
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            startIcon={<GroupAddOutlinedIcon />}
                            onClick={onQuickAssign}
                            disabled={disabled}
                            className={classes.quickAssign}
                        >
                            Quick assign
                        </Button>
                    </span>
                </Tooltip>
            </div>
        </div>
    );
};

export default AssignmentToolbar;
